"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnloadRequestSource = exports.AccountType = exports.UnloadStatus = void 0;
var UnloadStatus;
(function (UnloadStatus) {
    UnloadStatus["NEW"] = "NEW";
    UnloadStatus["CANCELLED"] = "CANCELLED";
    UnloadStatus["UNDER_INVESTIGATION"] = "UNDER_INVESTIGATION";
    UnloadStatus["APPROVED"] = "APPROVED";
    UnloadStatus["UNLOADED"] = "UNLOADED";
    UnloadStatus["PENDING_REFUND"] = "PENDING_REFUND";
    UnloadStatus["EXPORTED"] = "EXPORTED";
    UnloadStatus["FAILED"] = "FAILED";
    UnloadStatus["PROCESSING"] = "PROCESSING";
})(UnloadStatus = exports.UnloadStatus || (exports.UnloadStatus = {}));
var AccountType;
(function (AccountType) {
    AccountType["NEM_KONTO_CVR"] = "NEM_KONTO_CVR";
    AccountType["IBAN"] = "IBAN";
    AccountType["ACCOUNT_NUMBER"] = "ACCOUNT_NUMBER";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var UnloadRequestSource;
(function (UnloadRequestSource) {
    UnloadRequestSource["CLIENT"] = "CLIENT";
    UnloadRequestSource["OFFBOARDING"] = "OFFBOARDING";
    UnloadRequestSource["REFUND"] = "REFUND";
})(UnloadRequestSource = exports.UnloadRequestSource || (exports.UnloadRequestSource = {}));
//# sourceMappingURL=wallet-unload.js.map